import * as React from "react";
export class Tab extends React.Component {
    render() {
        return null;
    }
}
export default Tab;
//# sourceMappingURL=tab.js.map